module.exports = __webpack_public_path__ + "media/images/home/6-1639563d8e822511aad23a14ba816555.png";